export default {
  'TITLE_TAB': 'Sitios',
  'AP_WITH_COUNT': '{{count}} Dispositivo',
  'AP_WITH_COUNT_plural': '{{count}} Dispositivos',
  'PLACEMENT_NAME': 'Nombre',
  'PLACEMENT_MAC': 'Dirección MAC de la antena WiFi',
  'ENTITY_NAME': 'Sitio',
}